import { useContext } from 'react';
import { defaultContext } from '@tanstack/react-query';
import { useTasks } from '../../../../lib/tasks';
import { cardDecisionPrompt } from '../../../../lib/auto-approve-line';
import { AutoApproveLineText } from '../../tasks/AutoApproveLineText';
import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import styles from './SocialPostAutoApproveLine.module.css';

/**
 * Under a held post in the chat: what happens if the owner does not answer — "Goes out {time} unless you change it"
 * or "Won't go out unless you approve" (`lib/auto-approve-line.ts`). The card names only its task and question, so the
 * question is read off the account's task list (the island keeps it warm); once it is no longer open, nothing shows.
 * A surface with no data layer (a read-only render of the card) draws nothing.
 */
export function SocialPostAutoApproveLine({ card }: { card: SocialPostPreviewCardMetadata }) {
  const client = useContext(defaultContext);
  return client ? <LineFromTasks card={card} /> : null;
}

function LineFromTasks({ card }: { card: SocialPostPreviewCardMetadata }) {
  const { state } = useTasks();
  const prompt = cardDecisionPrompt(state.kind === 'ready' ? state.tasks : undefined, card);
  const choice = prompt?.autoApproveChoice;
  return choice ? <AutoApproveLineText choice={choice} dueBy={prompt?.dueBy} postAt={card.scheduledAt} className={styles.line} testId="socialPostAutoApprove" /> : null;
}
